import { tokenStorage } from './tokenStorage';

type UnauthorizedHandler = () => void;

let unauthorizedHandler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(handler: UnauthorizedHandler | null) {
  unauthorizedHandler = handler;
}

export function clearAuthSession() {
  tokenStorage.clear();
  unauthorizedHandler?.();
}
